import { render, staticRenderFns } from "./FolderRoute.vue?vue&type=template&id=7820b90d"
import script from "./FolderRoute.vue?vue&type=script&lang=js"
export * from "./FolderRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports